import TenantFilterButton from "./TenantFilterButton";
export default TenantFilterButton;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/TenantTagDesignDialog/index.tsx